module.exports = __webpack_public_path__ + "img/ta.e15465b5.svg";